import { render, staticRenderFns } from "./pathway.vue?vue&type=template&id=f2e1e674&scoped=true"
import script from "./pathway.vue?vue&type=script&lang=js"
export * from "./pathway.vue?vue&type=script&lang=js"
import style0 from "./pathway.vue?vue&type=style&index=0&id=f2e1e674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e1e674",
  null
  
)

export default component.exports